/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  useCuentaContableEmpresaComisionAperturaPrestamoConcedido,
  useCuentaContableEmpresaComisionCorretajePrestamoConcedido,
  useCuentaContableEmpresaComisionDisposicionPrestamoConcedido,
  useCuentaContableEmpresaComisionEstudioPrestamoConcedido,
  useCuentaContableEmpresaComisionOtraPrestamoConcedido,
  useCuentaContableEmpresaInteresPrestamoConcedido,
  useCuentaContableEmpresaPrestamoConcedido,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaComisionAperturaPrestamoConcedido,
  useCuentaContableCuentaComisionCorretajePrestamoConcedido,
  useCuentaContableCuentaComisionDisposicionPrestamoConcedido,
  useCuentaContableCuentaComisionEstudioPrestamoConcedido,
  useCuentaContableCuentaComisionOtraPrestamoConcedido,
  useCuentaContableCuentaInteresPrestamoConcedido,
  useCuentaContableCuentaPrestamoConcedido,
} from "api/CuentaContable_Cuenta.hook"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import { DropdownChangeParams } from "primereact/dropdown"
import { useTranslation } from "react-i18next"

const PrestamoConcedidoConfiguracion = ({
  initialPorDefectoPrestamoConcedido,
  handleSetPrestamo,
  initialPorDefectoPrestamoInteresConcedido,
  handleSetPrestamoInteres,
  initialPorDefectoPrestamoComisionAperturaConcedido,
  initialPorDefectoPrestamoComisionEstudioConcedido,
  initialPorDefectoPrestamoComisionDisposicionConcedido,
  initialPorDefectoPrestamoComisionCorretajeConcedido,
  initialPorDefectoPrestamoComisionOtrasConcedido,
  handleSetPrestamoApertura,
  handleSetPrestamoEstudio,
  handleSetPrestamoDisposicion,
  handleSetPrestamoCorretaje,
  handleSetPrestamoOtras,
  handlePrestamosCheckbox,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) => {
  const { t } = useTranslation()
  const { prestamoCheckboxState, handleFirstCheckbox, handleSecondCheckbox } =
    handlePrestamosCheckbox()

  const { cuentasContablesEmpresas: cuentasPrestamoBaseConcedido } =
    useCuentaContableCuentaPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoConcedido,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasPrestamoConcedido,
  } = useCuentaContableEmpresaPrestamoConcedido()
  const {
    cuentasContablesEmpresas:
      listaDeCuentasInteresesPrestamoConcedidoComprasBase,
  } = useCuentaContableCuentaInteresPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoInteresConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasPrestamoInteresConcedido,
  } = useCuentaContableEmpresaInteresPrestamoConcedido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionAperturaPrestamoConcedidoComprasBase,
  } = useCuentaContableCuentaComisionAperturaPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionAperturaConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionAperturaPrestamo,
  } = useCuentaContableEmpresaComisionAperturaPrestamoConcedido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionEstudioPrestamoConcedidoComprasBase,
  } = useCuentaContableCuentaComisionEstudioPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionEstudioBaseConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionEstudioPrestamo,
  } = useCuentaContableEmpresaComisionEstudioPrestamoConcedido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionDisposicionPrestamoConcedidoComprasBase,
  } = useCuentaContableCuentaComisionDisposicionPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionDisposicionBaseConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionDisposicionPrestamo,
  } = useCuentaContableEmpresaComisionDisposicionPrestamoConcedido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionCorretajePrestamoConcedidoComprasBase,
  } = useCuentaContableCuentaComisionCorretajePrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionCorretajeBaseConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionCorretajePrestamo,
  } = useCuentaContableEmpresaComisionCorretajePrestamoConcedido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionOtrosPrestamoConcedidoComprasBase,
  } = useCuentaContableCuentaComisionOtraPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionOtrasBaseConcedido,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasComisionOtraPrestamo,
  } = useCuentaContableEmpresaComisionOtraPrestamoConcedido()

  return (
    <div>
      <div className='tw-mb-4'>
        <div className='tw-mb-4 tw-w-full p-fluid'>
          {t("config.loanTitle")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={
              prestamoCheckboxState.firstCheckbox
                ? cuentasPrestamoBaseConcedido
                : cuentasPrestamoConcedido
            }
            dropdownValue={initialPorDefectoPrestamoConcedido ?? ""}
            onChange={(e: DropdownChangeParams) => handleSetPrestamo(e.value)}
            listaDeCuentasBase={cuentasPrestamoBaseConcedido}
            refreshFetchData={refresListaDeCuentasPrestamoConcedido}
            withCreateCuenta={!prestamoCheckboxState.firstCheckbox}
          />
        </div>
        <div className='tw-inline-flex tw-items-center tw-mb-4'>
          <input
            className='tw-h-5 tw-w-5 tw-accent-primary tw-rounded tw-cursor-pointer tw-mr-3'
            type='checkbox'
            name='concedidoCheckOne'
            id='concedidoCheckOne'
            onClick={() => handleFirstCheckbox()}
            checked={prestamoCheckboxState.firstCheckbox}
          />
          <label className='my-auto'>
            {t("config.crearCuentaContableAutomatica")}
          </label>
        </div>
        <div className='tw-inline-flex tw-items-center'>
          <input
            className='tw-h-5 tw-w-5 tw-accent-primary tw-rounded tw-cursor-pointer tw-mr-3 disabled:tw-cursor-not-allowed'
            type='checkbox'
            name='concedidoCheckTwo'
            id='concedidoCheck'
            disabled={!prestamoCheckboxState.firstCheckbox}
            onClick={() => handleSecondCheckbox()}
            checked={prestamoCheckboxState.secondCheckbox}
          />
          <label className='my-auto'>
            {t("config.asignarMismaCuentaContablePorContacto")}
          </label>
        </div>
      </div>

      <div className='tw-flex tw-flex-row tw-justify-between tw-mb-3 row'>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.interestTitle")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={cuentasPrestamoInteresConcedido}
            dropdownValue={initialPorDefectoPrestamoInteresConcedido ?? ""}
            onChange={(e: DropdownChangeParams) => {
              handleSetPrestamoInteres(e.value)
            }}
            listaDeCuentasBase={
              listaDeCuentasInteresesPrestamoConcedidoComprasBase
            }
            cuentaPorDefecto={initialPorDefectoPrestamoInteresConcedido}
            refreshFetchData={refresListaDeCuentasPrestamoInteresConcedido}
            withCreateCuenta
          />
        </div>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.originationFee")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={cuentasPrestamoComisionAperturaConcedido}
            dropdownValue={
              initialPorDefectoPrestamoComisionAperturaConcedido ?? ""
            }
            onChange={(e: DropdownChangeParams) =>
              handleSetPrestamoApertura(e.value)
            }
            listaDeCuentasBase={
              listaDeCuentasComisionAperturaPrestamoConcedidoComprasBase
            }
            cuentaPorDefecto={
              initialPorDefectoPrestamoComisionAperturaConcedido
            }
            refreshFetchData={refresListaDeCuentasComisionAperturaPrestamo}
            withCreateCuenta
          />
        </div>
      </div>

      <div className='tw-flex tw-flex-row tw-justify-between tw-mb-3 row'>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.studyCommission")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={
              cuentasPrestamoComisionEstudioBaseConcedido
            }
            dropdownValue={
              initialPorDefectoPrestamoComisionEstudioConcedido ?? ""
            }
            onChange={(e: DropdownChangeParams) =>
              handleSetPrestamoEstudio(e.value)
            }
            listaDeCuentasBase={
              listaDeCuentasComisionEstudioPrestamoConcedidoComprasBase
            }
            cuentaPorDefecto={initialPorDefectoPrestamoComisionEstudioConcedido}
            refreshFetchData={refresListaDeCuentasComisionEstudioPrestamo}
            withCreateCuenta
          />
        </div>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.arrangementFee")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={
              cuentasPrestamoComisionDisposicionBaseConcedido
            }
            dropdownValue={
              initialPorDefectoPrestamoComisionDisposicionConcedido ?? ""
            }
            onChange={(e: DropdownChangeParams) =>
              handleSetPrestamoDisposicion(e.value)
            }
            listaDeCuentasBase={
              listaDeCuentasComisionDisposicionPrestamoConcedidoComprasBase
            }
            cuentaPorDefecto={
              initialPorDefectoPrestamoComisionDisposicionConcedido
            }
            refreshFetchData={refresListaDeCuentasComisionDisposicionPrestamo}
            withCreateCuenta
          />
        </div>
      </div>

      <div className='tw-flex tw-flex-row tw-justify-between tw-mb-3 row'>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.brokerageCommission")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={
              cuentasPrestamoComisionCorretajeBaseConcedido
            }
            dropdownValue={
              initialPorDefectoPrestamoComisionCorretajeConcedido ?? ""
            }
            onChange={(e: DropdownChangeParams) =>
              handleSetPrestamoCorretaje(e.value)
            }
            listaDeCuentasBase={
              listaDeCuentasComisionCorretajePrestamoConcedidoComprasBase
            }
            cuentaPorDefecto={
              initialPorDefectoPrestamoComisionCorretajeConcedido
            }
            refreshFetchData={refresListaDeCuentasComisionCorretajePrestamo}
            withCreateCuenta
          />
        </div>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.otherCommission")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={cuentasPrestamoComisionOtrasBaseConcedido}
            dropdownValue={
              initialPorDefectoPrestamoComisionOtrasConcedido ?? ""
            }
            onChange={(e: DropdownChangeParams) =>
              handleSetPrestamoOtras(e.value)
            }
            listaDeCuentasBase={
              listaDeCuentasComisionOtrosPrestamoConcedidoComprasBase
            }
            cuentaPorDefecto={initialPorDefectoPrestamoComisionOtrasConcedido}
            refreshFetchData={refresListaDeCuentasComisionOtraPrestamo}
            withCreateCuenta
          />
        </div>
      </div>
    </div>
  )
}

export default PrestamoConcedidoConfiguracion
